// Menu de recherche
const searchBtn = document.querySelector('.mobile-search-btn');
if (searchBtn) {
    searchBtn.addEventListener('click', () => {
        const mainSearch = document.querySelector('.main-search');
        if (mainSearch) {
            mainSearch.classList.toggle('show-main-search');
        }
    });
}

// Menu mobile
const mobileMenuBtn = document.querySelector('.navbar-toggler');
if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', () => {
        document.body.classList.toggle('modale-open');
    });
}
